import React from "react"
import { AppWebSuppliersAutocomplete } from "@components"

import { useUserSettingsWebSupplierGroup, useUserSettingsWebSupplierGroupValidator } from "../../@hooks"
import { userSettingsWebSupplierGroupFormData } from "../../@signals"


export default function WebSupplierGroupDrawerWebSuppliers() {
	const { handleChangeFormData } = useUserSettingsWebSupplierGroup()
	const { webSuppliersError } = useUserSettingsWebSupplierGroupValidator()

	return <AppWebSuppliersAutocomplete
		placeholder="Select web suppliers"
		error={webSuppliersError}
		value={userSettingsWebSupplierGroupFormData.value?.web_suppliers || []}
		onChange={e => handleChangeFormData(e.target.value, 'web_suppliers')}
	/>
}